import React, { useState } from 'react';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, CircularProgress, Box, Slide } from '@mui/material';
import MailIcon from '@mui/icons-material/Mail';
import { useTheme } from '@mui/material/styles';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const GenerateReport = ({ onSendReport, loading }) => {
    const theme = useTheme();
    const [open, setOpen] = useState(false);
    const [email, setEmail] = useState('');

    // Handle dialog box
    const handleOpen = () => setOpen(true);
    const handleClose = () => {
        setEmail('');
        setOpen(false);
    };

    // Handle submit
    const handleSubmit = () => {
        onSendReport(email);
        handleClose();
    };

    return (
        <>
            <Button
                variant="outlined"
                size="large"
                onClick={handleOpen}
                disabled={loading}
                style={{
                    color: theme.palette.text.white,
                    borderColor: '#bbbdbd',
                    height: '52px',
                    width: '52px',
                    minWidth: '52px',
                    borderRadius: '12px',
                    padding: 0,
                }}
            >
                {loading ? <CircularProgress size={24} color="inherit" /> : <MailIcon />}
            </Button>

            <Dialog
                open={open}
                TransitionComponent={Transition}
                onClose={handleClose}
                aria-describedby="generate-report-dialog"
                PaperProps={{
                    sx: { backgroundColor: theme.palette.background.paper },
                }}
            >
                <DialogTitle variant="h2" fontWeight="bold">
                    Send Report
                </DialogTitle>
                <DialogContent sx={{ width: '500px', padding: '20px' }}>
                    <Box display="flex" flexDirection="column" gap={4}>
                        <TextField
                            label="Email"
                            variant="outlined"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            fullWidth
                            sx={{
                                marginTop: '1rem',
                            }}
                        />
                    </Box>
                </DialogContent>
                <DialogActions sx={{ padding: '16px 24px' }}>
                    <Button
                        onClick={handleClose}
                        variant="contained"
                        sx={{
                            color: theme.palette.text.black,
                            backgroundColor: theme.palette.text.white,
                            '&:hover': {
                                backgroundColor: theme.palette.text.white,
                            },
                            '&:focus': { outline: 'none' },
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={handleSubmit}
                        variant="contained"
                        disabled={!email || !/\S+@\S+\.\S+/.test(email)}
                        sx={{
                            color: theme.palette.text.black,
                            backgroundColor: theme.palette.text.white,
                            '&:hover': {
                                backgroundColor: theme.palette.text.white,
                            },
                            '&:focus': { outline: 'none' },
                        }}
                    >
                        {loading ? 'Sending...' : 'Send'}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default GenerateReport;
